import { Form } from '@ampol/design-system';
import clsx from 'clsx';
import Validation from 'constants/validation-messages';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { cardStatuses } from 'utilities/card-utilities';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  cardStatus: yup.string().required(Validation.STATUS_REQUIRED),
});

// eslint-disable-next-line no-unused-vars
enum SelectStatusFormNames {
  // eslint-disable-next-line no-unused-vars
  cardStatus = 'cardStatus',
}

export interface SelectStatusFormValues {
  [SelectStatusFormNames.cardStatus]: string;
}

interface SelectStatusFormProps {
  currentStatus: string;
  formId?: string;
  footerMessage?: string;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (values: SelectStatusFormValues) => void;
  disabled?: boolean;
}

export default function SelectStatusForm(props: SelectStatusFormProps) {
  const options = useMemo(
    () =>
      cardStatuses
        ?.find((status) => status.label === props.currentStatus)
        ?.allowedUpdateTargets?.map((status) => ({ label: status, value: status })),
    [props.currentStatus]
  );

  const canReadWrite = useSelector((state: any) => state.userStore.canReadWriteCards);

  return (
    <Form id={props.formId} onSubmit={props.onSubmit} schema={validationSchema}>
      <div className='w-full'>
        <Form.DropDown
          className={clsx('update-status-form__dropdown', props.disabled && 'pointer-events-none opacity-50')}
          label={'Card Status'}
          name={SelectStatusFormNames.cardStatus}
          options={options}
          disabled={props.disabled || !canReadWrite}
        />
      </div>

      {props.footerMessage && <div className='mt-s'>{props.footerMessage}</div>}
    </Form>
  );
}
